import React from 'react';
import { FadeIn } from '../FadeIn';
export function ProblemSolutionHome() {
  const problems = [{
    title: 'MINTEA',
    subtitle: 'GÂNDURI · OBOSEALĂ · ÎNTREBĂRI FĂRĂ RĂSPUNS',
    desc: 'Mintea ta nu mai tace. Te trezești obosită și adormi epuizată. Faci tot ce trebuie, dar undeva în interior se ridică aceeași întrebare: "Și eu acum ce fac?" Pare un gând banal. Nu este.'
  }, {
    title: 'EMOȚIILE',
    subtitle: 'EPUIZARE · FURIE · VINOVĂȚIE',
    desc: 'Cari greutate pentru toți, mai puțin pentru tine. Furia se acumulează în tăcere. Vinovăția vine de fiecare dată când îți alegi nevoile. Iar oboseala asta nu mai trece nici după concediu.'
  }, {
    title: 'RELAȚIILE',
    subtitle: 'DISTANȚĂ · TIPARE · SINGURĂTATE',
    desc: 'Te simți singură chiar și când ești înconjurată. Relațiile au devenit funcționale, nu sincere. Repeți tipare pe care le vedeai la mama ta și ești ultima pe propria listă de mult prea mult timp.'
  }];
  return <section className="py-20 md:py-28 bg-white overflow-hidden relative" data-id="element-580">
      {/* Organic blob background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-581">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-forest/5 rounded-full blur-3xl" data-id="element-582"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gold/5 rounded-full blur-3xl" data-id="element-583"></div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-584">
        <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-585">
          <FadeIn data-id="element-586">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-587">
              Te regăsești în ceva din ce urmează?
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-588">
          {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-589">
              <div className="bg-ivory/50 border border-gold/20 rounded-[24px] p-8 md:p-10 h-full flex flex-col hover:-translate-y-1 transition-transform duration-300 shadow-sm" data-id="element-590">
                <h3 className="text-2xl font-serif font-medium text-forest mb-2" data-id="element-591">
                  {problem.title}
                </h3>
                <p className="font-display text-[10px] font-semibold tracking-[0.2em] text-gold-dark uppercase mb-6 pb-4 border-b border-gold/20" data-id="element-592">
                  {problem.subtitle}
                </p>
                <p className="text-[17px] text-charcoal/80 leading-relaxed font-sans" data-id="element-593">
                  {problem.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}